/* Hourstick — interactions for the Craft theme port. Scoped: only touches [data-hs-*] elements. */
(function () {
  'use strict';
  var root = document.documentElement;
  var stored = null;
  try { stored = localStorage.getItem('hs-theme'); } catch (e) {}
  var mode = stored || (window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  root.setAttribute('data-hs-theme', mode);

  var SUN = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>';
  var MOON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';

  function paintToggles() {
    document.querySelectorAll('[data-hs-theme-toggle]').forEach(function (t) {
      t.innerHTML = mode === 'dark' ? SUN : MOON;
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hs-theme-toggle]');
    if (!t) return;
    mode = mode === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-hs-theme', mode);
    try { localStorage.setItem('hs-theme', mode); } catch (err) {}
    paintToggles();
  });

  function initReveals() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hs-reveal').forEach(function (el) { el.classList.add('hs-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('hs-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.hs-reveal:not(.hs-in)').forEach(function (el) { io.observe(el); });
  }

  function initStick() {
    document.querySelectorAll('[data-hs-stick]').forEach(function (stick) {
      var section = stick.closest('.shopify-section') || stick.closest('section') || stick.parentElement;
      function update() {
        var r = section.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        stick.style.setProperty('--burned', (p * 100).toFixed(1) + '%');
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function updateCartCount() {
    fetch((window.hsRoutes && window.hsRoutes.cartUrl || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-hs-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-hs-add-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    fetch((window.hsRoutes && window.hsRoutes.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (btn) {
        btn.textContent = 'Added \u2713';
        setTimeout(function () { btn.textContent = original; }, 1400);
      }
      updateCartCount();
    }).catch(function () {
      form.removeAttribute('data-hs-add-form');
      form.submit();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintToggles(); initReveals(); initStick(); });
  } else {
    paintToggles(); initReveals(); initStick();
  }

  document.addEventListener('shopify:section:load', function () {
    paintToggles(); initReveals(); initStick();
  });
})();
